import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ContentDataTable } from "src/components/Common/ContentDataTable";
import { SectionNoData } from "src/components/Common/SectionNoData";
import { IConfig, IReportedMessage } from "src/services/types";
import { getReportedMessages } from "src/services/users-service";
import { columnsReportsMessages } from "./ColumnsReportedMessages";
import { toast } from 'react-toastify';
import { SearchTable } from "src/components/Common/SearchTable";
import { Col, Row } from "reactstrap";
import { DetailsReportMessageModal } from "./DetailsReportMessageModal";

export const ReportedMessages = () => {
    document.title = "Secure | Users";

  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [reportedMessages, setReportedMessages] = useState<IReportedMessage[]>([]);
//   const [userSelected, setUserSelected] = useState<IReportedMessage | null>(null);
  const [showReportedMessageDetailModal, setShowReportedMessageDetailModal] = useState(false);
  const [itemSelected, setItemSelected] = useState<IReportedMessage>({} as IReportedMessage)
  const [config, setConfig] = useState<IConfig>({
      page: 1,
      per_page: 10,
      search: "",
  });
  const [userValidatingId, setUserValidatingId] = useState<string>('');

  const getData = async (config: IConfig) => {
    setIsLoading(true);
    const res = await getReportedMessages(config)
    setIsLoading(false);
    if (res.result === 'ok') {
        setTotalRows(res.data.pagination.total);
        setReportedMessages(res.data.data);
    } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error'});
    }
  }

  const showDetails = async (item: IReportedMessage) => {
    setItemSelected(item);
    setShowReportedMessageDetailModal(true)
  
    setUserValidatingId('');
  }

  const refresh = () => {
    getData(config);
  }

  useEffect(() => {
    getData(config);
  }, [config]);

  return (
    <>
      <div className="page-content">
          <h3 className="text-primary">Reported Messages</h3>
          <Row>
              <Col sm={6} className="d-flex align-items-center">
                    <button
                        type="button"
                        className="btn btn-soft-primary waves-effect waves-light"
                        onClick={refresh}
                    >
                        <i className="fas fa-sync-alt"></i> Refresh
                    </button>
              </Col>
              <Col sm={6} className="d-flex justify-content-end align-items-end" >
                  <div className="w-75">
                    <SearchTable 
                        onSearch={(search) => setConfig({ ...config, search, page: 1 })}
                        loading={isLoading && !!config.search}
                        className="mb-2"
                    />
                  </div>
              </Col>
          </Row>
         
          <ContentDataTable isLoading={isLoading}>
              <DataTable
                  customStyles={{}}
                  columns={columnsReportsMessages(config, userValidatingId, showDetails)}
                  data={reportedMessages}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  responsive
                  onChangeRowsPerPage={(per_page) => setConfig({ ...config, per_page, page: 1 })}
                  onChangePage={(page) => setConfig({ ...config, page })}
                  paginationDefaultPage={config.page}
                  paginationPerPage={config.per_page}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  noDataComponent={
                      <SectionNoData
                          onRefresh={() => getData(config)}
                          isLoading={isLoading}
                      />
                  }
              />
          </ContentDataTable>
      </div>
      
        <DetailsReportMessageModal
            show={showReportedMessageDetailModal}
            onClose={() => setShowReportedMessageDetailModal(false)}
            item={itemSelected}
        />

    </>
  )
}
